export class TableRow {
    public isSelected: boolean;
    public isSelectionFreezed: boolean;
    public isEdited: boolean;
    public isNewRow: boolean;
    public cells: {};
}
